<div class="infoBulle is-flex is-align-items-center">
  <mat-icon
    (mouseover)="toggleInfoBulle($event)"
    (mouseleave)="toggleInfoBulle($event)"
    class="blue-icon is-hidden-touch">
    info
  </mat-icon>
  <mat-icon
    (click)="toggleInfoBulle($event)"
    class="blue-icon is-hidden-desktop">
    info
  </mat-icon>
  @if (infoBulleMessage && isDisplayed) {
    <div
      (click)="toggleInfoBulle($event)"
      [ngStyle]="tooltipStyle"
      class="cards">
      <div class="content has-text-justified">{{ infoBulleMessage }}</div>
    </div>
  }
</div>
